import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const updatePpeComponentMasterQuery = (data) => {
    const { id } = data;
    delete data.id;
  return axios.put(`${apiurl?.updatePpeComponentMaster}/${id}`, data);
};

const updatePpeComponentMaster = () => {
  const queryClient = useQueryClient();
  return useMutation(updatePpeComponentMasterQuery, {
    onSuccess: () => {
      showAlert('The component details displayed on the Component Mapping screen will be modified.', 'success');
      queryClient.invalidateQueries('getAllPpeComponentMaster');
    },
    onError: (error) => {
      showAlert(error?.response?.data, 'error');
    }
  });
};

export default updatePpeComponentMaster;
